import styled from "styled-components/macro";
import { DeviceType } from "../../../utils/hooks/useDeviceHook";
import { StyledButton } from "../Button/Button.styles";

const getDeviceWidth = (deviceType: DeviceType): string => {
  if (deviceType === "mobile") return "calc(100% - 10px);";
  return "650px";
};

export const ProfileModalWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  width: ${({ deviceType }) => getDeviceWidth(deviceType)};
  margin: ${({ deviceType }) =>
    deviceType === "desktop" ? undefined : "10px 10px"};
  justify-content: center;
  max-height: 80vh;
  background: white;
  border-radius: 16px;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
  overflow-x: hidden;
  overflow-y: scroll;

  .profile-modal-title {
    margin-top: 40px;
    padding-left: ${({ deviceType }) =>
      deviceType === "desktop" ? undefined : "10px"};
  }

  .profile-insurance-title {
    margin-bottom: 20px;
  }
`;

export const ProfileModalTitleWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  display: flex;
  grid-gap: 8px;
  padding: ${({ deviceType }) =>
    deviceType === "desktop" ? "12px 20px" : "12px 25px"};
  justify-content: space-between;
  font-size: 16px;
  width: 100%;
  align-items: center;
  margin-bottom: -5px;

  svg {
    cursor: pointer;
  }
`;

export const ProfileModalContentWrapper = styled.div`
  margin: 24px;
`;

export const ProfileModalTitle = styled.div<{
  deviceType: DeviceType;
}>`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.neutral50};
  width: 100%;
  color: ${({ theme }) => theme.greyDark};
  border: 1px solid ${({ theme }) => theme.neutral100};
  box-sizing: border-box;
  font-weight: 800;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 1.2px;
  border-radius: 8px;
  border-bottom-right-radius: unset;
  border-bottom-left-radius: unset;
  svg {
    margin-top: -4px;
    margin-left: 5px;
  }
`;

export const CenteredModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
`;

export const ProfileModalButtons = styled.div<{
  deviceType: DeviceType;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 12px 20px;
  gap: 16px;
  margin: 0;

  ${StyledButton} {
    height: 48px;
    min-width: 120px;
    flex: 1;
    text-align: center;
    box-sizing: border-box;
  }
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #212529;
  margin-bottom: 10px;
`;

export const Subtitle = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.greyMedium};
`;
